var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBolt = function SvgBolt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "1em",
    viewBox: "0 0 512 512",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m397.141 11.37-94.368 200.897h98.819v.028c2.013 0 4.026.737 5.585 2.268 3.146 3.061 3.203 8.107.142 11.254l-275.65 283.756a7.96 7.96 0 0 1-9.099 1.672c-3.968-1.871-5.698-6.605-3.827-10.602l100.944-215.099H110.38v-.028c-1.134 0-2.268-.255-3.373-.766-3.969-1.842-5.698-6.605-3.827-10.574l126.315-268.9c1.105-3.061 4.054-5.273 7.512-5.273h152.905v.028a7.9 7.9 0 0 1 3.373.766c3.998 1.842 5.727 6.605 3.856 10.573z",
    fill: "#ffd64f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m208.178 430.824 184.625-190.068 14.514-14.939c3.062-3.147 3.004-8.193-.142-11.254-1.559-1.531-3.572-2.268-5.585-2.268l-98.819-.028 94.37-200.897.028-.057c1.814-3.969.085-8.675-3.884-10.517a7.915 7.915 0 0 0-3.373-.766L370.976.002 257.871 240.756h95.19L135.666 464.558l-16.923 36.086c-1.871 3.997-.142 8.731 3.827 10.602a7.961 7.961 0 0 0 9.099-1.672z",
    fill: "#f99e2f",
    fillRule: "evenodd"
  })));
};
export default SvgBolt;